<template>
    <relatorio-page :titulo=" 'Relatório Frequência' " :cabecalhoCompleto="true" :exportarExcel="false" :paisagem="false">

        <v-row v-if="item">

            <v-col v-if="modoListagem" cols="12" sm="12" md="12">

                <v-simple-table id="tabela" dense class="py-2 text-caption">
                    <template v-slot: default>
                        <thead class="fonte" style="background-color: #4A70A8">
                            <tr>
                                <th style="font-size: 100% ; color: white" class="text-left fonte">Projeto</th>
                            </tr>
                        </thead>

                        <tbody class="fonte" v-for="(item, index) in item" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                            <tr>                               
                                <td style="font-size: 110%" class="font-weight-bold">{{item.projeto}}</td>
                            </tr>

                            <tr>
                                <td class="px-1">
                                    <v-simple-table dense>
                                        <template v-slot:default>
                                            <thead class="fonte" style="background-color: #4A70A8">
                                                <tr> 
                                                    <th class="text-left fonte" style="font-size: 100% ; color: white">Data</th>
                                                    <th class="text-left fonte" style="font-size: 100% ; color: white">Beneficiário</th>
                                                    <th class="text-left fonte" style="font-size: 100% ; color: white">Situação</th>
                                                    <th class="text-left fonte" style="font-size: 100% ; color: white">Observação</th>
                                                </tr>
                                            </thead>
                                            <tbody class="fonte" v-for="(beneficiario, index) in item.itens" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                                                <tr>
                                                    <td class="text-left" style="font-size: 100%">{{new Date(beneficiario.data).ddmmyyyy()}}</td>
                                                    <td class="text-left" style="font-size: 100%">{{beneficiario.beneficiario}}</td>
                                                    <td class="text-left" style="font-size: 100%">{{beneficiario.situacao == 'P' ? 'Presente' : beneficiario.situacao == 'F' ? 'Faltou' : beneficiario.situacao == 'V' ? 'Vazio' : ''}}</td>
                                                    <td class="text-left" style="font-size: 100%">{{beneficiario.observacao}}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </td>
                            </tr>

                        </tbody>
                    </template>
                </v-simple-table>

            </v-col>

            <v-col v-else cols="12" sm="12" md="12">

                <div v-if="projeto.id > 0">
                    <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <span class="font-weight-bold">Projeto: </span> <span>{{projeto.nome}}</span>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span class="font-weight-bold">Meta Beneficiários: </span> <span>{{projeto.metaBeneficiario}}</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <span class="font-weight-bold">Período das Atividades: </span> <span>{{new Date(projeto.dataInicio).ddmmyyyy()}} {{projeto.dataTermino ? 'a ' + new Date(projeto.dataTermino).ddmmyyyy() : ''}}</span>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span class="font-weight-bold">Qtd. Beneficiários: </span> <span>{{projeto.beneficiarios.length}}</span>
                        </v-col>
                    </v-row>
                </div>

                <v-simple-table id="tabela" dense class="py-2 text-caption">
                    <template v-slot: default>
                        <thead class="fonte" style="background-color: #4A70A8">
                            <tr>
                                <th style="font-size: 100% ; color: white" class="text-left fonte">Beneficiário</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Qtd. Atividades</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Presença</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Presença %</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Faltas</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Faltas %</th>
                            </tr>
                        </thead>
                        <tbody class="fonte">
                            <tr v-for="(item, index) in item" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                                <td style="font-size: 100%" class="text-left">{{item.beneficiario}}</td>
                                <td style="font-size: 100%" class="text-center">{{item.quantidadeAtividade}}</td>                                
                                <td style="font-size: 100%" class="text-center">{{item.quantidadePresenca}}</td>
                                <td style="font-size: 100%" class="text-center">{{item.quantidadePresencaPercentual ? item.quantidadePresencaPercentual.toMoeda() : item.quantidadePresencaPercentual}}</td>                                
                                <td style="font-size: 100%" class="text-center">{{item.quantidadeFalta}}</td>
                                <td style="font-size: 100%" class="text-center">{{item.quantidadeFaltaPercentual ? item.quantidadeFaltaPercentual.toMoeda() : item.quantidadeFaltaPercentual}}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>

            </v-col>

        </v-row>

        <v-row v-else>
            <v-col cols="12">
                Nenhum registro foi encontrado.
            </v-col>
        </v-row>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </relatorio-page>
</template>

<script>
import { Projeto } from '../../../core/domain/projetos';
import { FrequenciaService, ProjetoService } from '../../../core/services/projetos';

export default {
    
    data: () => ({
        item:{
            required: true
        },
        filter:{
            required: true
        },
        service: new FrequenciaService(),
        projetoService: new ProjetoService(),
        overlay: false,
        modoListagem: false,
        projeto: new Projeto()
    }),
    props:{

    },
    mounted(){

        this.filter = this.$route.query;

        this.modoListagem = this.filter.modoListagem == "true" ? true : false;

        this.overlay = true;

        if(this.modoListagem){
            this.service.RelatorioSimples(this.filter.projetoId, this.filter.dataInicio, this.filter.dataTermino, this.filter.beneficiarioId, this.filter.beneficiarioId, "Beneficiario, Data").then(
                res =>{
                    this.item = res.data;
                },
                err =>{
                    this.$swal('Aviso', err.message, 'error');
                }
            ).finally(() =>{
                this.overlay = false;
            })
        }
        else{

            this.projetoService.ObterPorId(this.filter.projetoId, "Beneficiarios").then(
                res =>{
                    this.projeto = res.data
                },
                err => this.$swal('Aviso', err.message, 'error')
            )

            this.service.RelatorioGerencial(this.filter.projetoId, this.filter.dataInicio, this.filter.dataTermino).then(
                res =>{
                    this.item = res.data;
                },
                err =>{
                    this.$swal('Aviso', err.message, 'error');
                }
            ).finally(() =>{
                this.overlay = false;
            })
        }
    }
}
</script>

<style>
    .fonte{
        font-size: 90%;
    }
</style>